import "./SidePanelSection.less";
import * as React from "react";
import { BaseResponsiveComponent } from "../../BaseResponsiveComponent";
import { inject, observer } from "mobx-react";

export interface ISidePanelSectionProps {}

@inject()
@observer
class SidePanelSection extends BaseResponsiveComponent<ISidePanelSectionProps> {
    renderAll() {
        const { children } = this.props;

        return <div className="SidePanelSection single-line">{children}</div>;
    }
}

export default SidePanelSection;
